import React from "react";
import { Time, TimeProps } from "../Time";
import { Typography } from "../Typography";

export interface CalendarLabelProps extends Omit<
  React.HTMLAttributes<HTMLParagraphElement>,
  "color"
> {
  size?: "small" | "medium" | "large";
  date?: TimeProps["date"];
  children?: never;
}

export const CalendarLabel = ({
  date,
  size = "medium",
  ...props
}: CalendarLabelProps) => {
  return (
    <div>
      <Typography
        variant={size === "medium" ? "h2" : size === "small" ? "h3" : "h1"}
        as="p"
        {...props}
      >
        <Time year="numeric" month="short" date={date} />
      </Typography>
    </div>
  );
};
